import Link from "next/link";
import Logo from "../../components/Icons/Logo";
import {
  Form,
  FormErrorMessage,
  FormField,
  FormLabel,
  InputFormField,
  useFormState,
} from "../form";
import { Button } from "ui";

export function LoginForm({
  onSubmit,
}: {
  onSubmit: (values: { email: string; password: string }) => Promise<any>;
}) {
  return (
    <>
      <div>
        <Logo />
        <h1 className="mt-10 text-2xl font-medium text-foundations-boldest">
          Login to your account
        </h1>
      </div>

      <Form<{ email: string; password: string }>
        onSubmit={onSubmit}
        className="mt-6 space-y-6"
      >
        <FormField
          label="Email"
          name="email"
          required
          validation="required|email"
        >
          <FormLabel />
          <InputFormField placeholder="Enter your email" type="email" />
          <FormErrorMessage />
        </FormField>

        <FormField
          label="Password"
          name="password"
          required
          validation="required"
        >
          <FormLabel />
          <InputFormField
            placeholder="Enter your password"
            type="password"
            autoComplete="new-password"
          />
          <FormErrorMessage />
        </FormField>

        <div className="flex items-center justify-end">
          <Link
            href="/forgot-password"
            className="text-sm text-info focus:underline focus:outline-none"
          >
            Forgot your password?
          </Link>
        </div>

        <div>
          <FormActionButton />
          <FormServerErrors />
        </div>
      </Form>
    </>
  );
}

const FormActionButton = () => {
  const { isSubmitting } = useFormState();
  return (
    <Button
      variant="primary"
      type="submit"
      className="w-full"
      isLoading={isSubmitting}
    >
      Login
    </Button>
  );
};

const FormServerErrors = () => {
  const { errors } = useFormState();
  if (!errors.root?.message) return null;
  return (
    <p className="mt-2 text-center text-sm text-danger">
      {errors.root?.message}
    </p>
  );
};
